import {DailyTransactionTypeEnum, LookupItemModel, LookupTypeEnum} from "../../../../models";
import {create} from "zustand";
import {getLookupByType} from "../../../../serviceBroker/lookupApiServiceBroker";
import {getUserSetting, getUserTransactionsSettings} from "../../../../serviceBroker/userApiServiceBroker";
import {getUserId} from "../../../../utils";
import {SystemConfiguration} from "../../../../configuration";
import {getCompanySettings} from "../businessLogic/transactionBl";

interface TransactionInitializationState {
    // Parameters
    transactionType: DailyTransactionTypeEnum | null;
    formId: number | null;
    // Data
    beneficiaryList: LookupItemModel[];
    originalBeneficiaryList: LookupItemModel[];
    categoryList: LookupItemModel[];
    itemList: LookupItemModel[];
    itemsPerCategoryList: LookupItemModel[];
    paymentTypeList: LookupItemModel[];
    currencyList: LookupItemModel[];
    storeEmployeeList: LookupItemModel[];
    costCenterList: LookupItemModel[];
    calcTypeList: LookupItemModel[];
    storeList: LookupItemModel[];

    //userConfiguration:UserConfigurationModel|null;
    // Calculated properties
    isSalesComponent: boolean;
    hasSingleStore: boolean;
    defaultStoreId: number | null;

    // State flags
    loading: boolean;
    isLoaded: boolean;

    // Actions
    initialize: (transactionType: DailyTransactionTypeEnum, formId: number) => Promise<void>;
    // Setters
    setBeneficiaryList: (list: LookupItemModel[]) => void;
    setOriginalBeneficiaryList: (list: LookupItemModel[]) => void;
    setCategoryList: (list: LookupItemModel[]) => void;
    setItemList: (list: LookupItemModel[]) => void;
    setItemsPerCategoryList: (list: LookupItemModel[]) => void;
    setPaymentTypeList: (list: LookupItemModel[]) => void;
    setCurrencyList: (list: LookupItemModel[]) => void;
    setStoreEmployeeList: (list: LookupItemModel[]) => void;
    setCostCenterList: (list: LookupItemModel[]) => void;
    setCalcTypeList: (list: LookupItemModel[]) => void;
    setStoreList: (list: LookupItemModel[]) => void;
    //setUserConfiguration: (userConfiguration:UserConfigurationModel) => void;
    setLoading: (loading: boolean) => void;
    setIsLoaded: (isLoaded: boolean) => void;
    setIsSalesComponent: (isSalesComponent: boolean) => void;
    setHasSingleStore: (hasSingleStore: boolean) => void;
    setDefaultStoreId: (defaultStoreId: number | null) => void;
    resetState: () => void;
}
const makeSafeArray = <T>(input: T[] | null | undefined): T[] => {
    return Array.isArray(input) ? input : [];
};
const isSalesComponent = (transactionType: DailyTransactionTypeEnum):boolean => {
    return [
        DailyTransactionTypeEnum.SalesInvoice,
        DailyTransactionTypeEnum.SalesRefund,
        DailyTransactionTypeEnum.ShowPrice,
        DailyTransactionTypeEnum.Order,
        DailyTransactionTypeEnum.POSSales,
        DailyTransactionTypeEnum.POSSalesRefund,
        DailyTransactionTypeEnum.POSRestaurant,
        DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
        DailyTransactionTypeEnum.ReturnPOSRestaurant,
    ].includes(transactionType);
}

const  loadAllData = async (transactionType: DailyTransactionTypeEnum, formId: number) => {
    let  stores = await getLookupByType(LookupTypeEnum.Stores, true, false);
   // const { genericSystemConfigurations, isConfigurationLoaded } = useGenericSystemConfigurations();
    stores=stores??[];
    const _isSalesComponent = isSalesComponent(transactionType);
    const  _hasSingleStore =  stores.length <= 1;
    const _defaultStoreId = _hasSingleStore ? Number(stores[0].value) : null;
    const [
        beneficiaryLookupList,
        CategoryLookupList,
        itemLookupList,
        paymentTypeLookupList,
        currencyLookupList,
        employeeLookupList,
        calcTypeLookupList,
        costCenterLookupList,
        _userSetting,
        _userTransactionSettingList,
        _companySetting
    ] = await Promise.all([
        _isSalesComponent
            ? getLookupByType(LookupTypeEnum.Customers, true, false)
            : getLookupByType(LookupTypeEnum.Supplier, true, false),
        getLookupByType(LookupTypeEnum.CategoryType, true, true),
        _hasSingleStore ?getLookupByType(LookupTypeEnum.Items, true, true):Promise.resolve([]),
        getLookupByType(LookupTypeEnum.PaymentType, true, true),
        getLookupByType(LookupTypeEnum.Currency, true, true),
        getLookupByType(LookupTypeEnum.Employee, true, true),
        getLookupByType(LookupTypeEnum.CalcType, true, false),
        getLookupByType(LookupTypeEnum.CostCenter, true, true),
        getUserSetting(getUserId()),
        getUserTransactionsSettings(
            [
                DailyTransactionTypeEnum.SalesInvoice,
                DailyTransactionTypeEnum.PurchasesInvoice,
                DailyTransactionTypeEnum.SalesRefund,
                DailyTransactionTypeEnum.PurchasesRefund,
                DailyTransactionTypeEnum.Order,
                DailyTransactionTypeEnum.ShowPrice,
                DailyTransactionTypeEnum.POSSales,
                DailyTransactionTypeEnum.POSSalesRefund,
                DailyTransactionTypeEnum.POSRestaurant,
                DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
                DailyTransactionTypeEnum.ReturnPOSRestaurant,
            ],
            true,
            SystemConfiguration.cacheKey_Configurations.setting.userTransactionSettingsList
        ),
        getCompanySettings()
    ]);
    return {
        beneficiaryList: beneficiaryLookupList,
        originalBeneficiaryList: beneficiaryLookupList,
        categoryList: CategoryLookupList,
        itemList: itemLookupList,
        itemsPerCategoryList: itemLookupList,
        paymentTypeList: paymentTypeLookupList,
        currencyList: currencyLookupList,
        storeEmployeeList: employeeLookupList,
        costCenterList: costCenterLookupList,
        calcTypeList: calcTypeLookupList,
        storeList: stores,
        // userConfiguration:{
        //     userSetting:_userSetting,
        //     companySetting:_companySetting,
        //     userTransactionSettingList:_userTransactionSettingList,
        //     //userTransactionSetting:null,
        //   //  genericSystemConfiguration:genericSystemConfigurations,
        // },
        isSalesComponent:_isSalesComponent,
        hasSingleStore:_hasSingleStore,
        defaultStoreId:_defaultStoreId,
    }
}
export const useTransactionInitializationStore = create<TransactionInitializationState>((set, get) => ({
    // Initial state
    transactionType: null,
    formId: null,
    beneficiaryList: [],
    originalBeneficiaryList: [],
    categoryList: [],
    itemList: [],
    itemsPerCategoryList: [],
    paymentTypeList: [],
    currencyList: [],
    storeEmployeeList: [],
    costCenterList: [],
    calcTypeList: [],
    storeList: [],
    userConfiguration:null,
    isSalesComponent: false,
    hasSingleStore: false,
    defaultStoreId: null,
    loading: false,
    isLoaded: false,
//Action
    initialize: async (transactionType, formId) => {
        set({ loading: true, isLoaded:false, transactionType, formId });
        try {
            const data = await loadAllData(transactionType, formId);
            set({
                ...data,
                loading: false,
                isLoaded: true
            });
        } catch (error) {
            console.error('Store initialization failed:', error);
            set({ loading: false, isLoaded: false });
            throw error;
        }
    },
    // Setters for lookup lists
    setBeneficiaryList: (list) => {set({beneficiaryList: makeSafeArray(list)})},
    setOriginalBeneficiaryList: (list) => {set({originalBeneficiaryList: makeSafeArray(list)})},
    setCategoryList: (list) => {set({categoryList: makeSafeArray(list)})},
    setItemList: (list) => {set({itemList: makeSafeArray(list)})},
    setItemsPerCategoryList: (list) => {set({itemsPerCategoryList: makeSafeArray(list)})},
    setPaymentTypeList: (list) => {set({paymentTypeList: makeSafeArray(list)})},
    setCurrencyList: (list) => {set({currencyList: makeSafeArray(list)})},
    setStoreEmployeeList: (list) => {set({storeEmployeeList: makeSafeArray(list)})},
    setCostCenterList: (list) => {set({costCenterList: makeSafeArray(list)})},
    setCalcTypeList: (list) => {set({calcTypeList: makeSafeArray(list)})},
    setStoreList: (list) => {set({storeList: makeSafeArray(list)})},
  //  setUserConfiguration: (userConfiguration) => {set({userConfiguration:userConfiguration})},
    // Setters for flags
    setLoading: (loading) => {set({loading})},
    setIsLoaded: (isLoaded) => {set({isLoaded})},
    // Setters for derived properties
    setIsSalesComponent: (isSalesComponent) => set({ isSalesComponent }),
    setHasSingleStore: (hasSingleStore) => set({ hasSingleStore }),
    setDefaultStoreId: (defaultStoreId) => set({ defaultStoreId }), resetState: () => set({
        // Reset all lookup data
        beneficiaryList: [],
        originalBeneficiaryList: [],
        categoryList: [],
        itemList: [],
        itemsPerCategoryList: [],
        paymentTypeList: [],
        currencyList: [],
        storeEmployeeList: [],
        costCenterList: [],
        calcTypeList: [],
        storeList: [],
      //  userConfiguration: null,

        // Reset derived values
        isSalesComponent: false,
        hasSingleStore: false,
        defaultStoreId: null,

        // Reset flags
        loading: false,
        isLoaded: false,
    })
}));